import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { dateIcon } from "../assets/imgs";
import { LabelContainer } from "../assets/style";

export default function SearchDatePicker(props: { title: any, value: any, setMethod: Function, style?: any }) {
    const { title, value, setMethod, style } = props
    // const datePickerStyle = {
    //     margin: "10px",
    //     backgroundColor: "white",
    //     borderColor: "black",
    //     maxWidth: "176px",
    //     width: "100%",
    //     ...style,
    // };
    const datePickerStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        // height: "100px",
        width: "100%",
        ...style,
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "400px",
    };
    return (
        <div style={containerStyle}>
            <LabelContainer >
                {title + ": "}
            </LabelContainer>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    format="DD/MM/YYYY"
                    sx={datePickerStyle}
                    value={value}
                    onChange={(date) => {
                        setMethod(date);
                    }}
                    slots={{
                        openPickerIcon: DateIcon
                    }}
                    slotProps={{ textField: { size: 'small', color: 'primary' } }}
                />

            </LocalizationProvider>

        </div>
    );
}

function DateIcon() {
    return (
        <img src={dateIcon} alt="" />
    );
}
